<script lang="ts">
  import Stepper from "./Stepper.svelte";
  import DetailsForm from "./DetailsForm.svelte";
  import Explain from "./Explain.svelte";
  import QuestionComponent from "./QuestionComponent.svelte";
  import SubmitComponent from "./SubmitComponent.svelte";
  import BackendOffline from "./BackendOffline.svelte";
  import { questions } from "./questions.ts";

  import { submitStatus, SUBMIT_STATUS, backendStatus, BACKEND_STATUS } from "./data.ts";

  const questionComponents = questions.map(question => ({
    component: QuestionComponent,
    props: {
      question
    }
  }));
</script>

<style>

</style>

{#if $backendStatus === BACKEND_STATUS.OFFLINE}
  <BackendOffline />
{:else if $submitStatus === SUBMIT_STATUS.IDLE}
  <Stepper
    comps={[{ component: DetailsForm }, { component: Explain }, ...questionComponents]} />
{:else}
  <SubmitComponent />
{/if}
